import { registerDecorator } from '@avensia/excite-contentful/Document';
import * as React from 'react';
import Image from '../components/image/index';
import { styled } from '@glitz/react';

registerDecorator<Excite.Contentful.EmbeddedAssetApiModel>(
  'img',
  styled(({ children, data }) => <Image image={data} />),
);
